// extracted by css-extract-rspack-plugin
export default {"breadcrumbs":"wKd6s"};